import React from "react";
import MetaData from "../layout/MetaData";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { setCartItem, removeCartItem } from "../../redux/features/cartSlice";

const Cart = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { cartItems } = useSelector((state) => state.cart);

    // Increase qty
    const increaseQty = (item, quantity) => {
        const newQty = quantity + 1;
        if (newQty > item?.stock) return;
        setItemToCart(item, newQty);
    };

    // Decrease qty
    const decreaseQty = (item, quantity) => {
        const newQty = quantity - 1;
        if (newQty <= 0) return;
        setItemToCart(item, newQty);
    };

    const setItemToCart = (item, newQty) => {
        const cartItem = {
            product: item?.product,
            name: item?.name,
            price: item?.price,
            image: item?.image,
            stock: item?.stock,
            quantity: newQty,
        };
        dispatch(setCartItem(cartItem));
    };

    const removeCartItemHandler = (id) => {
        dispatch(removeCartItem(id));
    };

    const checkoutHandler = () => {
        navigate("/shipping");
    }

    return (
        <>
            <MetaData title={"Your Cart"} />

            <main className="main-content mt-3">
                <div className="cart-card d-flex justify-content-center align-items-start mt-4 mt-md-5 px-2 px-md-0">
                    <div
                        // style={{ maxWidth: "1000px" }}
                    >
                        {cartItems?.length === 0 ? (
                            <div className="d-flex justify-content-center align-items-center flex-column text-center my-5" >
                                <div
                                    className="cart-card shadow-sm rounded-4 d-flex flex-column justify-content-center align-items-center"
                                    style={{ width: '70vw', maxWidth: 320, aspectRatio: '1 / 1', padding: '1rem' }}
                                >
                                    <h2 className="fw-bold text-danger">Your Cart is Empty</h2>
                                    <Link to="/" className="btn View-btn mt-3">
                                        Go Shopping
                                    </Link>
                                </div>
                            </div>
                        ) : (
                            <>
                                {/* Page Title */}
                                <h2 className=" cart-card fw-bold text-center mb-4 mb-md-5 mt-2 mt-md-3" style={{ color: "#e04f6ecd" }}>
                                    Your Cart :{" "}
                                    <b className="text-primary">{cartItems?.length} items</b>
                                </h2>

                                <div className="row g-3 g-md-4">
                                    {/* Cart Items */}
                                    <div className="col-12 col-lg-8">
                                        <div className="cart-card shadow-sm rounded-4 p-3">
                                            {cartItems?.map((item, i) => (
                                                <div
                                                    key={i}
                                                    className={`row align-items-start align-items-sm-center mb-3 pb-3 ${i !== cartItems.length - 1 ? "border-bottom" : ""}`}
                                                >
                                                    {/* Image */}
                                                    <div className="col-12 col-sm-3 text-center mb-2 mb-sm-0">
                                                        <img
                                                            src={item?.image}
                                                            alt={item?.name}
                                                            className="img-fluid rounded"
                                                            height="90"
                                                            width="115"
                                                        />
                                                    </div>

                                                    {/* Name */}
                                                    <div className="col-12 col-sm-4">
                                                        <Link
                                                            to={`/products/${item?.product}`}
                                                            className="fw-semibold text-decoration-none text" style={{ color: "#e04f6ecd" }}
                                                        >
                                                            {item?.name}
                                                        </Link>
                                                    </div>

                                                    {/* Price */}
                                                    <div className="col-6 col-sm-2 mt-2 mt-sm-0">
                                                        <p className="fw-bold " style={{ color: "#e91e63" }}>
                                                            PKR {item?.price}
                                                        </p>
                                                    </div>

                                                    {/* Qty + Delete */}
                                                    <div className="col-6 col-sm-3 mt-2 mt-sm-0">
                                                        <div className="d-flex align-items-center justify-content-between gap-2">
                                                            <div className="input-group input-group-sm w-auto">
                                                                <button
                                                                    className="btn btn-outline-danger btn-sm"
                                                                    onClick={() =>
                                                                        decreaseQty(item, item.quantity)
                                                                    }
                                                                >
                                                                    -
                                                                </button>
                                                                <input
                                                                    type="number"
                                                                    className="form-control text-center count"
                                                                    value={item?.quantity}
                                                                    readOnly
                                                                />
                                                                <button
                                                                    className="btn btn-outline-primary btn-sm"
                                                                    onClick={() =>
                                                                        increaseQty(item, item.quantity)
                                                                    }
                                                                >
                                                                    +
                                                                </button>
                                                            </div>

                                                            <i
                                                                id="delete_cart_item"
                                                                className="fa fa-trash btn btn-danger ms-2"
                                                                onClick={() =>
                                                                    removeCartItemHandler(item?.product)
                                                                }
                                                            ></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Order Summary */}
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div
                                            className=" cart-card shadow-sm rounded-4 p-3 bg-body "
                                            style={{
                                                minHeight: "250px",
                                                position: "sticky",
                                                top: "90px",
                                            }}
                                        >
                                            <h4 className="fw-bold" style={{ color: "#e04f6ecd" }}>Order Summary</h4>
                                            <hr />
                                            <p style={{ color: "#e04f6ecd" }}>
                                                Subtotal:{" "}
                                                <span className="fw-semibold text-primary" >
                                                    {cartItems.reduce(
                                                        (acc, item) => acc + item?.quantity,
                                                        0
                                                    )}
                                                </span>
                                            </p>
                                            <p style={{ color: "#e04f6ecd" }}>
                                                Est. total:{" "}
                                                <span className="fw-bold text " style={{ color: "#e91e63"}}>
                                                    PKR{" "}
                                                    {cartItems
                                                        .reduce(
                                                            (acc, item) => acc + item.price * item.quantity,
                                                            0
                                                        )
                                                        .toFixed(2)}
                                                </span>
                                            </p>
                                            <hr />
                                            <button id="checkout_btn" className="btn View-btn w-100" onClick={checkoutHandler}>
                                                Proceed to Checkout
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </main>
        </>
    );
};

export default Cart;
